import React from "react";
import { Box } from "@mui/material";

export const getRoleColor = (roleName: string) => {
  const roleColors = {
    TeamMember: "#82B184",
    Mentor: "#5B93D3",
    Observer: "#9A9A9A",
    Instructor: "#FFEE58",
    CohortAdministrator: "#D76969",
  };
  return roleColors[roleName] || "#9A9A9A";
};

export const AllRoleCell = ({ cell }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "4px",
      backgroundColor: getRoleColor(cell.getValue()),
      color: cell.getValue() === "Instructor" ? "rgba(0, 0, 0, 0.8)" : "#fff",
      padding: "1px 3px",
      fontSize: "0.875rem",
      fontWeight: 500,
    }}
  >
    {cell.getValue()}
  </Box>
);
